// TODO: import from platform-utils when available
const copyFromClipboard = async () => {
  try { return await navigator.clipboard.readText() } catch { return '' }
}

const ADD_PROPERTY = 'add-property'
const PASTE_PROPERTY = 'paste-property'
const ADD_CHILDREN = 'add-children'
const EDIT_CHILDREN = 'edit-children'
const DEL_CHILDREN = 'del-children'
const COPY_CHILDREN = 'copy-children'
const PASTE_CHILDREN = 'paste-children'
const DUP_CHILDREN = 'dup-children'

export const getSideBarContextMenu = (el, s, sharedProps, currentLayer) => {
  const childrenOptions = [
    {
      key: ADD_PROPERTY,
      text: 'Add Property'
    },
    {
      key: PASTE_PROPERTY,
      text: 'Paste Property'
    },
    {
      key: ADD_CHILDREN,
      text: 'Add Children'
    },
    {
      key: EDIT_CHILDREN,
      text: 'Edit Children'
    },
    {
      key: DEL_CHILDREN,
      text: 'Delete Children'
    },
    {
      key: COPY_CHILDREN,
      text: 'Copy Children'
    },
    {
      key: PASTE_CHILDREN,
      text: 'Paste Children'
    },
    {
      key: DUP_CHILDREN,
      text: 'Duplicate Children'
    }
  ]

  return {
    ...sharedProps,
    options: childrenOptions,

    DropdownHeader: {
      hide: false,
      text: s.key || s.title
    },

    onChoose: async function (ev, el, s, ctx, calleeElement) {
      const actionKey = calleeElement.state.key
      const { key: sidebarKey, type: sidebarType } = currentLayer.lookup(
        (el) => el.sidebarItem
      )?.state || {
        key: null,
        type: null
      }
      const layerPath =
        currentLayer
          .call(
            'getTargetLayerPath',
            currentLayer.state,
            sidebarKey,
            sidebarType
          )
          ?.filter(Boolean) || []

      if (actionKey === PASTE_PROPERTY || actionKey === PASTE_CHILDREN) {
        const sourceLayerPath = await copyFromClipboard()

        if (!sourceLayerPath) {
          console.warn('No clipboard data found', sourceLayerPath)
        }

        const copiedKeyName = `${sourceLayerPath[sourceLayerPath.length - 1]}_copy`

        const propOrChildName = sourceLayerPath[sourceLayerPath.length - 1]

        const isProperty = /^[a-z]/.test(propOrChildName[0])

        if (isProperty && actionKey === PASTE_CHILDREN) {
          return
        }

        currentLayer.call(
          'addClonedPropOrChild',
          sourceLayerPath,
          layerPath,
          copiedKeyName
        )

        return
      }

      if (actionKey === ADD_PROPERTY || actionKey === ADD_CHILDREN) {
        const newPropName = 'propName'
        const newChildName = 'NewChild'

        const propOrChildName =
          actionKey === ADD_PROPERTY ? newPropName : newChildName

        const calculatedNewName = currentLayer.call(
          'getAvailableNamesOnLayer',
          layerPath,
          propOrChildName
        )

        if (actionKey === ADD_PROPERTY) {
          await currentLayer.call(
            'addLayerProp',
            calculatedNewName,
            'propValue'
          )
        } else {
          await currentLayer.call('addLayerChildren', calculatedNewName)
        }
        return
      }
      if (actionKey === DEL_CHILDREN) {
        const confirmMsg = `Do you want to remove "${layerPath.join(' > ')}"?`
        if (!window.confirm(confirmMsg)) {
          return false
        }
        el.sdk.updateData(
          [
            ['delete', layerPath, null],
            ['delete', ['schema', ...layerPath, 'code']]
          ],
          { preventItemSidebarElementUpdate: true }
        )

        currentLayer.remove()
        return
      }
      if (actionKey === EDIT_CHILDREN) {
        // currentLayer.setWindow('componentEditor', 'code')
        // currentLayer.activateSelected(sidebarKey)
        const data = currentLayer.getCanvasScope()
        data.componentEditor = 'code'
        currentLayer.changeCodePriority('component')

        data.activeLayer = layerPath

        currentLayer.syncCanvas()
        currentLayer
          .getComponentCodeEditor()
          .update({}, { preventUpdate: true, allowCodeSelection: true })
        return
      }
      if (actionKey === COPY_CHILDREN) {
        el.call('copyStringToClipboard', JSON.stringify(layerPath))

        return
      }
      if (actionKey === DUP_CHILDREN) {
        const childrenPath = layerPath

        const keyName = `${childrenPath[childrenPath.length - 1]}_duplicate`

        const duplicatedKey = currentLayer.call(
          'getAvailableNamesOnLayer',
          layerPath,
          keyName
        )

        const currentComponent = el.call('getDataItemByLayerPath', childrenPath)

        if (!currentComponent) {
          console.error(
            'No component found at the specified path:',
            childrenPath
          )
          return
        }

        let duplicatedComponent = el.call('deepClone', currentComponent)

        const newLayerPath = [
          ...childrenPath.slice(0, childrenPath.length - 1),
          duplicatedKey
        ]

        el.sdk.updateData([
          ['update', newLayerPath, duplicatedComponent],
          ['delete', ['schema', ...newLayerPath.slice(0, 2), 'code']]
        ])

        return
      }
      el.activateContext(null)
    }
  }
}
